export default {
	passwordChange: {
        oldPass: "Старый пароль",
        newPass: "Новый пароль",
        change: "Изменить",
	}
};